(() => {
  "use strict";

  function injectStyles() {
    if (document.getElementById("print-studio-preview-polish-style")) return;

    const style = document.createElement("style");
    style.id = "print-studio-preview-polish-style";
    style.textContent = `
      .print-studio {
        --preview-wall: #f6f4ef;
        --preview-floor: #ebe5dc;
        --preview-shadow: rgba(35, 29, 24, .24);
        --preview-soft-shadow: rgba(35, 29, 24, .13);
        --paper-frame-rail: 15px;
        --floater-rail-polished: clamp(4px, .78vw, 8px);
        --floater-gap-polished: clamp(5px, .8vw, 9px);
      }

      .print-studio__scene {
        background:
          linear-gradient(180deg, rgba(255,255,255,.72), rgba(255,255,255,0) 34%),
          linear-gradient(128deg, #faf9f6 0%, #f0ede7 52%, #e6ded3 100%);
        border-right-color: rgba(32,34,41,.10);
      }

      .print-studio__wall {
        width: 100%;
        height: 100%;
        aspect-ratio: auto;
        overflow: hidden;
        background:
          linear-gradient(180deg, rgba(255,255,255,.9) 0%, rgba(255,255,255,.46) 42%, rgba(255,255,255,0) 68%),
          linear-gradient(180deg, var(--preview-wall) 0 67%, var(--preview-floor) 67% 100%);
        box-shadow: inset -1px 0 0 rgba(255,255,255,.38);
      }

      .print-studio__wall::before {
        content: "";
        position: absolute;
        left: 0;
        right: 0;
        top: 67%;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(80,70,60,.10), transparent);
      }

      .print-studio__wall::after {
        content: "";
        position: absolute;
        left: 50%;
        top: 50%;
        width: min(54vw, 520px);
        height: min(34vh, 230px);
        transform: translate(-50%, 42%) perspective(520px) rotateX(62deg);
        background: radial-gradient(ellipse at center, rgba(45,37,31,.18) 0%, rgba(45,37,31,.10) 37%, transparent 70%);
        filter: blur(18px);
        opacity: .72;
        pointer-events: none;
      }

      .print-studio__ledge {
        display: none;
      }

      .print-studio__frame {
        border-radius: 0;
        transform: translateZ(0);
        will-change: width, aspect-ratio, padding, box-shadow;
      }

      .print-studio__frame.is-print-only {
        background: transparent;
        box-shadow:
          0 30px 56px var(--preview-soft-shadow),
          0 8px 18px rgba(35,29,24,.08);
      }

      .print-studio__frame.is-stock-frame,
      .print-studio__frame.is-paper-print.has-frame-visual {
        padding: var(--paper-frame-rail);
        background-color: var(--frame);
        background-image: var(--frame-surface);
        box-shadow:
          0 42px 74px var(--preview-shadow),
          0 14px 26px rgba(35,29,24,.15),
          inset 0 0 0 1px rgba(255,255,255,.20),
          inset 0 0 0 2px rgba(0,0,0,.12);
      }

      .print-studio__frame.is-stock-frame[data-frame-style="White"],
      .print-studio__frame.is-paper-print.has-frame-visual[data-frame-style="White"] {
        box-shadow:
          0 42px 74px rgba(35,29,24,.18),
          0 14px 26px rgba(35,29,24,.12),
          inset 0 0 0 1px rgba(255,255,255,.82),
          inset 0 0 0 2px rgba(75,69,62,.12);
      }

      .print-studio__frame.is-stock-frame[data-frame-style="Black"],
      .print-studio__frame.is-paper-print.has-frame-visual[data-frame-style="Black"],
      .print-studio__frame.is-floater[data-frame-style="Black"] {
        background-color: #050505;
        background-image: linear-gradient(135deg, rgba(255,255,255,.08), rgba(0,0,0,.28));
      }

      .print-studio__frame.is-stock-frame .print-studio__mat,
      .print-studio__frame.is-paper-print.has-frame-visual .print-studio__mat {
        padding: 0;
        background: transparent;
      }

      .print-studio__frame.is-stock-frame .print-studio__art,
      .print-studio__frame.is-paper-print.has-frame-visual .print-studio__art {
        background: #f8f7f3;
        box-shadow:
          0 0 0 1px rgba(0,0,0,.10),
          inset 0 0 0 1px rgba(255,255,255,.35);
      }

      .print-studio__frame.is-stock-frame .print-studio__art img,
      .print-studio__frame.is-paper-print.has-frame-visual .print-studio__art img {
        object-fit: cover;
      }

      .print-studio__frame.is-canvas {
        padding: 0;
        background: transparent;
        filter: none;
        box-shadow:
          0 34px 58px rgba(35,29,24,.18),
          0 10px 22px rgba(35,29,24,.10);
      }

      .print-studio__frame.is-canvas .print-studio__mat {
        padding: 0;
        background: transparent;
      }

      .print-studio__frame.is-canvas .print-studio__art {
        border: 1px solid rgba(32,34,41,.12);
        box-shadow:
          inset -7px 0 12px rgba(0,0,0,.045),
          inset 0 -7px 12px rgba(0,0,0,.045);
      }

      .print-studio__frame.is-floater {
        padding: var(--floater-rail-polished);
        background-color: var(--frame);
        background-image: var(--frame-surface);
        box-shadow:
          0 32px 62px rgba(35,29,24,.24),
          0 12px 24px rgba(35,29,24,.14),
          inset 0 0 0 1px rgba(255,255,255,.18),
          inset 0 0 0 1.5px rgba(0,0,0,.12);
      }

      .print-studio__frame.is-floater .print-studio__mat {
        padding: var(--floater-gap-polished);
        background: #050505;
        box-shadow:
          inset 0 0 0 1px rgba(255,255,255,.08),
          inset 0 0 8px rgba(0,0,0,.55);
      }

      .print-studio__frame.is-floater .print-studio__art {
        border: 0;
        box-shadow:
          0 8px 16px rgba(0,0,0,.26),
          0 1px 2px rgba(0,0,0,.28),
          inset -5px 0 10px rgba(0,0,0,.04),
          inset 0 -5px 10px rgba(0,0,0,.04);
      }

      .print-studio__frame.is-floater::before,
      .print-studio__frame.is-floater::after {
        display: none;
      }

      .print-studio__frame.is-canvas::before {
        top: 4px;
        right: -5px;
        bottom: 2px;
        width: 5px;
        opacity: .65;
        border-radius: 0;
      }

      .print-studio__frame.is-canvas::after {
        left: 4px;
        right: -3px;
        bottom: -5px;
        height: 5px;
        opacity: .65;
        border-radius: 0;
      }

      .print-studio__art {
        background:
          linear-gradient(135deg, rgba(217,95,61,.08), rgba(34,91,111,.08)),
          #fbfaf7;
      }

      .print-studio__art span {
        max-width: 11em;
        color: rgba(32,34,41,.42);
        font-size: .92rem;
        line-height: 1.25;
      }

      @media (min-width: 941px) {
        .print-studio {
          min-height: 620px;
        }

        .print-studio__scene {
          height: clamp(560px, calc(100svh - 150px), 780px);
          min-height: 560px;
          grid-template-rows: minmax(330px, 1fr) auto;
        }

        .print-studio__preview-controls {
          grid-template-columns: repeat(4, minmax(0, 1fr));
          align-items: end;
          gap: 10px;
          padding: 12px clamp(20px, 3vw, 34px) 14px;
        }

        .print-studio__preview-controls .print-studio__fit-note {
          display: none;
        }

        .print-studio__preview-controls label {
          gap: 5px;
          font-size: .82rem;
          line-height: 1.2;
        }

        .print-studio__crop-actions {
          align-self: end;
          grid-column: 1 / -1 !important;
          grid-template-columns: repeat(5, minmax(0, 1fr));
          gap: 6px;
        }

        .print-studio__crop-mode,
        .print-studio__crop-reset {
          min-height: 34px;
          padding: 0 6px;
          font-size: .74rem;
          line-height: 1.1;
        }

        .print-studio__content {
          align-content: start;
          gap: 14px;
          padding: clamp(24px, 3.2vw, 48px);
        }

        .print-studio__brand-mark {
          width: min(180px, 42vw);
        }

        .print-studio h1 {
          font-size: clamp(2rem, 3.5vw, 4rem);
        }

        .print-studio__intro {
          font-size: .98rem;
          line-height: 1.45;
        }

        .print-studio form {
          gap: 11px;
        }

        .print-studio__panel {
          padding: 18px;
        }

        .print-studio__upload {
          min-height: 118px;
          padding: 18px;
        }
      }

      @media (max-width: 940px) {
        .print-studio__scene {
          min-height: 500px;
          border-bottom-color: rgba(32,34,41,.10);
        }

        .print-studio__wall::after {
          width: min(76vw, 470px);
          height: 190px;
        }
      }

      @media (max-width: 640px) {
        .print-studio {
          --paper-frame-rail: 15px;
          --floater-rail-polished: clamp(4px, 2vw, 7px);
          --floater-gap-polished: clamp(5px, 2.2vw, 8px);
        }

        .print-studio__scene {
          min-height: 430px;
        }
      }

      @media (max-width: 700px) {
        .print-studio__scene,
        .print-studio.has-artwork .print-studio__scene {
          height: clamp(138px, 23vh, 184px) !important;
          min-height: 0 !important;
          max-height: 184px !important;
          overflow: hidden !important;
        }

        .print-studio.has-artwork .print-studio__scene {
          height: clamp(154px, 25vh, 210px) !important;
          max-height: 210px !important;
        }

        .print-studio__wall,
        .print-studio.has-artwork .print-studio__wall {
          height: 100% !important;
          min-height: 0 !important;
          max-height: none !important;
        }

        .print-studio__wall::after {
          width: 190px;
          height: 76px;
          filter: blur(14px);
        }
      }
    `;
    document.head.append(style);
  }

  function removeMatLook(studio) {
    const frame = studio.querySelector("[data-frame]");
    if (!frame) return;

    const isStock = frame.classList.contains("is-stock-frame") || frame.classList.contains("has-frame-visual") && frame.classList.contains("is-paper-print");
    if (isStock) {
      studio.style.setProperty("--mat", "0px");
    }
  }

  function patchStudio(Studio) {
    const proto = Studio && Studio.prototype;
    if (!proto || proto.__previewPolishPatched) return;

    proto.__previewPolishPatched = true;
    const originalUpdatePreview = proto.updatePreview;
    const originalSync = proto.sync;

    proto.updatePreview = function () {
      if (originalUpdatePreview) originalUpdatePreview.call(this);
      removeMatLook(this);
    };

    proto.sync = function () {
      if (originalSync) originalSync.call(this);
      removeMatLook(this);
    };
  }

  function init() {
    injectStyles();
    const Studio = customElements.get("print-frame-studio");
    patchStudio(Studio);
    document.querySelectorAll("print-frame-studio").forEach((studio) => {
      removeMatLook(studio);
      if (typeof studio.updatePreview === "function") studio.updatePreview();
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", injectStyles);
  else injectStyles();

  if (window.customElements && window.customElements.whenDefined) window.customElements.whenDefined("print-frame-studio").then(init);
})();
